import { CryptoError } from './errors.js'
import { bytesToHex } from './encoding.js'

/**
 * The only allowed randomness source (CSPRNG). Nonces are never derived from
 * counters; keys and recovery secrets come from here.
 */
export function randomBytes(byteLength: number): Uint8Array<ArrayBuffer> {
  if (!Number.isInteger(byteLength) || byteLength <= 0) {
    throw new CryptoError('CRYPTO_INVALID_INPUT', 'randomBytes requires a positive integer length')
  }
  const bytes = new Uint8Array(byteLength)
  globalThis.crypto.getRandomValues(bytes)
  return bytes
}

export function randomHex(byteLength: number): string {
  return bytesToHex(randomBytes(byteLength))
}
